import { paperClasses } from '@mui/material/Paper';
import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiCard = {
  styleOverrides: {
    root: ({ theme }) => {
      const isDark = theme.palette.mode === 'dark';
      return {
        borderRadius: '16px',
        backgroundImage: isDark
          ? 'linear-gradient(180deg, rgba(255, 255, 255, 0.025) 0%, rgba(255, 255, 255, 0) 60%)'
          : 'none',
        transition: 'box-shadow 200ms ease, border-color 200ms ease, background-color 200ms ease',
        ...(isDark && {
          backgroundColor: 'var(--mui-palette-neutral-900)',
          border: '1px solid rgba(255, 255, 255, 0.06)',
        }),
        [`&.${paperClasses.elevation1}`]: {
          boxShadow: isDark
            ? '0 1px 2px rgba(0, 0, 0, 0.45), 0 8px 24px rgba(0, 0, 0, 0.35), inset 0 0 0 1px rgba(255, 255, 255, 0.06)'
            : '0 1px 2px rgba(16, 24, 40, 0.04), 0 4px 18px rgba(16, 24, 40, 0.06), inset 0 0 0 1px rgba(16, 24, 40, 0.06)',
        },
      };
    },
  },
} satisfies Components<Theme>['MuiCard'];
